export default "//static.tradera.net/touchweb/static/output/images/push-selling-icon.f032a8b4.svg";